export const IFRAME_CALLBACK_EVENT =
  '@rushplay/shufti-pro/IFRAME_CALLBACK_EVENT'

export const TYPES = {
  IDENTITY: 'identity',
  ADDRESS: 'address',
  ADDITIONAL: 'additional',
}

export const STATUS = {
  VERIFIED: 'verified',
  REJECTED: 'rejected',
  PENDING: 'pending',
}
